(() => {
  const $removeError = $('.ph-search-order-form input[type="text"]');

  const resetSearch = () => {
    ACC.registerpagebuttons.removeInfo($removeError);
    $('.ph-search-order-form input[type="text"]').val('');
  };

  $('.ph-os-radioButtons[type="radio"]').click((event) => {
    $('.ph-os-noResult_error').addClass('hidden');

    if ($(event.currentTarget).attr('id') === 'ph-os-no') {
      $('.ph-os-StoreRadio').removeClass('hidden');
      $('#ph-os-matc').attr('checked', true);
    } else {
      $('.ph-os-StoreRadio').addClass('hidden');
      $('#ph-os-matc').attr('checked', false);
    }
  });

  const submitValidations = () => {
    if ($('.ph-os-buttonValidations_anonymous').length > 0) {
      $('.ph-search-order-form input[type="text"]').each(function() {
        if ($(this).val() === '' && !$(this).closest('.ph-search-order-form').hasClass('ph-disabledbutton')) {
          ACC.registerpagebuttons.addRemove(this);
        }
      });
    } else {
      $('.ph-search-order-form input[type="text"]').each(function() {
        if ($(this).val() === '' &&
        !$(this).closest('.ph-search-order-form').hasClass('ph-disabledbutton') &&
        !$(this).closest('.ph-hiddenBoxes').hasClass('hidden')) {
          ACC.registerpagebuttons.addRemove(this);
        }
      });
    }
  };

  $(document).on('blur', '#accountNumber', function() {
    const numbervalidate = $('#accountNumber input').val();

    const accountNumb = $(this).attr('id');

    ACC.registerPage.isEmptyValue(accountNumb);

    if (numbervalidate !== '') {
      if (ACC.validation.numeric(numbervalidate)) {
        $('#accountNumber').find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
        $('#accountNumber').find('.ph-register__emptyvalue').text($('#accountNumber').attr('data-numericContent'));
      } else {
        $('#confirmationNumber').find('.ph-signup__error').removeClass('form_field_error ph-form_field_error');
        $('#confirmationNumber').find('.ph-register__emptyvalue').text();
      }
    }
  });

  $(document).on('blur', '#confirmationNumber', function() {
    const numbervalidate = $('#confirmationNumber input').val();

    const accountNumb = $(this).attr('id');

    ACC.registerPage.isEmptyValue(accountNumb);

    if (numbervalidate !== '') {
      if (ACC.validation.numeric(numbervalidate)) {
        $('#confirmationNumber').find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
        $('#confirmationNumber').find('.ph-register__emptyvalue').text($('#confirmationNumber').attr('data-numericContent'));
      } else {
        $('#confirmationNumber').find('.ph-signup__error').removeClass('form_field_error ph-form_field_error');
        $('#confirmationNumber').find('.ph-register__emptyvalue').text();
      }
    }
  });

  $(document).on('blur', '#materialNum', function() {
    const materialNumber = $(this).attr('id');

    ACC.registerPage.isEmptyValue(materialNumber);
  });

  $(document).on('blur', '#shiptoNumber', function() {
    const numbervalidate = $('#shiptoNumber input').val();

    const accountNumb = $(this).attr('id');

    ACC.registerPage.isEmptyValue(accountNumb);

    if (numbervalidate !== '') {
      if (ACC.validation.numeric(numbervalidate)) {
        $('#shiptoNumber').find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
        $('#shiptoNumber').find('.ph-register__emptyvalue').text($('#shiptoNumber').attr('data-numericContent'));
      } else {
        $('#shiptoNumber').find('.ph-signup__error').removeClass('form_field_error ph-form_field_error');
        $('#shiptoNumber').find('.ph-register__emptyvalue').text();
      }
    }
  });

  $(document).on('blur', '#purchaseNum', function() {
    const purchaseNumber = $(this).attr('id');

    ACC.registerPage.isEmptyValue(purchaseNumber);
  });

  $(document).on('blur', '#ph-search__date', function() {
    const fromDate = $(this).attr('id');

    ACC.registerPage.isEmptyValue(fromDate);
  });


  $(document).on('click', '#onestoreSearchSubmit', () => {
    submitValidations();
  });

  /**
   * @returns {void} - This returns nothing.
   * @example newSearchOrder()
   */
  const osSearchOrder = () => {
    document.querySelector('#ph-onestore__searchselect').onchange = function() {
      $('.ph-search-order-form input[type="text"]').each(() => {
        resetSearch();
      });

      $('.ph-os-noResult_error').addClass('hidden');

      if (this.value === 'confirmationNumber') {
        $('.ph-search__nonconfirmation').addClass('hidden ph-disabledbutton ');
        $('.ph-confirmationnumber').removeClass('hidden ph-disabledbutton');
        $('.ph-search__nonconfirmation input').val('');
      } else if (this.value === 'shipTo') {
        $('.ph-confirmationnumber,.ph-search__materialnumber, .ph-search__purchaseordernumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input,.ph-search__materialnumber input, .ph-search__purchaseordernumber input').val('');
        $('.ph-search__nonconfirmation,.ph-search__accountnumber').removeClass('hidden ph-disabledbutton');
      } else if (this.value === 'materialNo') {
        $('.ph-confirmationnumber,.ph-search__accountnumber, .ph-search__purchaseordernumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input,.ph-search__accountnumber input, .ph-search__purchaseordernumber input').val('');
        $('.ph-search__nonconfirmation,.ph-search__materialnumber').removeClass('hidden ph-disabledbutton');
      } else if (this.value === 'purchaseOrderNumber') {
        $('.ph-confirmationnumber,.ph-search__accountnumber, .ph-search__materialnumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input,.ph-search__accountnumber input, .ph-search__materialnumber input').val('');
        $('.ph-search__nonconfirmation,.ph-search__purchaseordernumber').removeClass('hidden ph-disabledbutton');
      } else {
        $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input').val('');
      }
    };
  };

  /**
   * @returns {void} - This returns nothing.
   * @example newAnonymousSearchOrder()
   */
  const osAnonymousSearchOrder = () => {
    document.querySelector('#ph-onestore__anonymousselect').onchange = function() {
      $('.ph-os-noResult_error').addClass('hidden');

      $('.ph-search-order-form input[type="text"]').each(() => {
        resetSearch();
      });

      if (this.value === 'confirmationNumber') {
        $('.ph-search__nonconfirmation').addClass('hidden ph-disabledbutton');
        $('.ph-search__nonconfirmation input').val('');
        $('.ph-confirmationnumber').removeClass('hidden ph-disabledbutton');
      } else if (this.value === 'soldTo') {
        $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input').val('');
        $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
        ACC.orderSearch.datePickerInit($('#fromDate'));
        ACC.orderSearch.datePickerInit($('#toDate'));
        $('#anonymousSearchOrderForm .anonymous_holder.setTwoHolder').removeClass('disabled');
        $('#anonymousSearchOrderForm .anonymous_holder.setTwoHolder input').attr('disabled', false);
        $('.ph-searchorder-setTwoHolder').removeClass('disabled');
        $('.ph-searchorder-setOneHolder').removeClass('enabled');
      } else {
        $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input').val('');
      }
    };
  };


  window.addEventListener('DOMContentLoaded', () => {
    if (document.querySelectorAll('#ph-onestore__searchselect').length > 0) {
      osSearchOrder();
      $('#ph-onestore__searchselect option').each(function() {
        if ($(this).prop('selected')) {
          if (this.value === 'confirmationNumber') {
            $('.ph-search__nonconfirmation').addClass('hidden ph-disabledbutton');
            $('.ph-confirmationnumber').removeClass('hidden ph-disabledbutton');
          } else if (this.value === 'shipTo') {
            $('.ph-confirmationnumber,.ph-search__materialnumber, .ph-search__purchaseordernumber').addClass('hidden ph-disabledbutton');
            $('.ph-search__nonconfirmation,.ph-search__accountnumber').removeClass('hidden ph-disabledbutton');
          } else if (this.value === 'materialNo') {
            $('.ph-confirmationnumber,.ph-search__accountnumber, .ph-search__purchaseordernumber').addClass('hidden ph-disabledbutton');
            $('.ph-search__nonconfirmation,.ph-search__materialnumber').removeClass('hidden ph-disabledbutton');
          } else if (this.value === 'purchaseOrderNumber') {
            $('.ph-confirmationnumber,.ph-search__accountnumber, .ph-search__materialnumber').addClass('hidden ph-disabledbutton');
            $('.ph-search__nonconfirmation,.ph-search__purchaseordernumber').removeClass('hidden ph-disabledbutton');
          } else {
            $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
            $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
          }
        }
      });
      $('.ph-selectsearch select').focus(function() {
        $(this).siblings('label').addClass('ph-selectlabel');
      });

      $('.ph-selectsearch select').focusout(function() {
        $(this).siblings('label').removeClass('ph-selectlabel');
      });
    }
  });

  window.addEventListener('DOMContentLoaded', () => {
    if (document.querySelectorAll('#ph-onestore__anonymousselect').length > 0) {
      osAnonymousSearchOrder();
      $('#ph-onestore__anonymousselect option').each(function() {
        if ($(this).prop('selected')) {
          if (this.value === 'confirmationNumber') {
            $('.ph-search__nonconfirmation').addClass('hidden ph-disabledbutton');
            $('.ph-confirmationnumber').removeClass('hidden ph-disabledbutton');
          } else if (this.value === 'soldTo') {
            $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
            $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
          } else {
            $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
            $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
          }
        }
      });
      $('.ph-selectsearch select').focus(function() {
        $(this).siblings('label').addClass('ph-selectlabel');
      });

      $('.ph-selectsearch select').focusout(function() {
        $(this).siblings('label').removeClass('ph-selectlabel');
      });
    }
  });
  /* eslint-disable no-extend-native */
  Date.prototype.addDays = function(days) {
    /* eslint-enable no-extend-native */
    const date = new Date(this.valueOf());

    date.setDate(date.getDate() + days);

    return date;
  };

  const date = new Date();
  const searchStartEnd = $('.ph-dateFormat').text($('.ph-dateFormat').text().replace('yyyy', 'yy'));


  $('#fromDate').datepicker({
    maxDate: date,
    dateFormat: searchStartEnd.text().toLowerCase(),
    onSelect() {
      const toDate = $('#fromDate').datepicker('getDate');
      /* eslint-disable no-ternary */
      const setDt = toDate.addDays(30) > date ? date : toDate.addDays(30);

      /* eslint-enable no-ternary */
      $('#toDate').datepicker('option', 'minDate', toDate);
      $('#toDate').datepicker('setDate', setDt);
      $('#toDate').datepicker('option', 'maxDate', setDt);
      $(this).blur();
    },
    endDate: 'today'
  });
  $('#toDate').datepicker({
    maxDate: date,
    dateFormat: searchStartEnd.text().toLowerCase(),
    onSelect() {
      $('#fromDate').datepicker('option', 'maxDate', 0);
      $(this).blur();
    },
    endDate: 'today'
  });
})();
